import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ConsistencyPage } from './features/admin/ConsistencyPage';
import { MasterDataPage } from './features/admin/MasterDataPage';
import { EventLogPage } from './features/events/EventLogPage';
import { FolderDetailPage } from './features/folders/FolderDetailPage';
import { RegisterPage } from './features/folders/RegisterPage';
import { SearchPage } from './features/folders/SearchPage';
import { HomePage } from './features/me/HomePage';
import { LabelBatchDetailPage } from './features/labels/LabelBatchDetailPage';
import { LabelBatchListPage } from './features/labels/LabelBatchListPage';
import { LocationDetailPage } from './features/locations/LocationDetailPage';
import { LocationListPage } from './features/locations/LocationListPage';

/**
 * A SPA mélylinkjeit a szerver `index.html`-lel szolgálja ki
 * (`web-static.module.ts`), ezért a `createBrowserRouter` (valódi URL-ek)
 * használható — nem kell hash-alapú routing.
 *
 * Az útvonalak magyarul vannak, mert a felület is magyar (spec 17.1 §), és
 * a dolgozók megosztott linkjei így önmagukat magyarázzák.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/mappak" replace /> },
      // A „Keresés" beolvadt a Mappák oldalba (D fázis, 7.1): az ugyanaz a
      // lista volt, csak szűrők nélkül. A régi útvonal átirányít, hogy a
      // dolgozók elmentett linkjei ne törjenek el.
      { path: 'kereses', element: <Navigate to="/mappak" replace /> },
      { path: 'mappak', element: <SearchPage /> },
      { path: 'mappak/uj', element: <RegisterPage /> },
      { path: 'mappak/:barcode', element: <FolderDetailPage /> },
      // A „Raklapok" MENÜPONT megszűnt (2026-08-14-i CR #15): a raklap a
      // három lokációtípus egyike, és a Lokációknak van saját menüpontja. Az
      // ÚTVONAL viszont marad, átirányításként — elmentett linkek mutathatnak rá.
      { path: 'raklapok', element: <Navigate to="/lokaciok?tipus=PALLET" replace /> },
      { path: 'cimkek', element: <LabelBatchListPage /> },
      { path: 'cimkek/:batchId', element: <LabelBatchDetailPage /> },
      { path: 'lokaciok', element: <LocationListPage /> },
      { path: 'lokaciok/:barcode', element: <LocationDetailPage /> },
      { path: 'naplo', element: <EventLogPage /> },
      { path: 'torzsadatok', element: <MasterDataPage /> },
      { path: 'ellenorzes', element: <ConsistencyPage /> },
      { path: 'fiok', element: <HomePage /> },
    ],
  },
]);
